export default __webpack_public_path__ + "static/media/26.56fc60b5.svg";